import { StrikeZoneRectMatrixProps } from './strikeZone.types';

export const strikeZoneDataValueKey: string = 'data-strike-zone-value';
export const strikeZoneDataTypeKey: string = 'data-strike-zone-type';
export const strikeZoneDeselectedEvent: string = 'deselect';
export const strikeZoneSelectedEvent: string = 'select';
export const viewBoxMinX: number = 0;
export const viewBoxMinY: number = 21;
export const viewBoxWidth: number = 206;
export const viewBoxHeight: number = 325;
export const zoneWidth: number = 50;
export const zoneHeight: number = 75;
export const outlierWidth: number = 103;
export const outlierHeight: number = 141;
export const homePlateWidth: number = 152;
export const homePlateHeight: number = 28;
export const strokeWidth: number = 2;
export const keyCodes: any = {
    enter: 13,
    space: 32,
    tab: 9,
};
export const zoneAltText: string = 'Inner';
export const outlierAltText: string = 'Outer';
export const strikeZoneSelectedClassName: string = 'strikeZoneSelected';

const commonOutlierProps: any = {
    type: 'outlier',
    textAnchor: 'start',
    dominantBaseline: 'text-before-edge',
};

const commonOutlierUpperLeftProps: any = {
    textTransform: 'translate(6px, 6px)',
    ...commonOutlierProps,
};

const commonOutlierUpperRightProps: any = {
    textTransform: 'translate(83px, 6px)',
    ...commonOutlierProps,
};

const commonOutlierBottomLeftProps: any = {
    textTransform: 'translate(6px, 119px)',
    ...commonOutlierProps,
};

const commonOutlierBottomRightProps: any = {
    textTransform: 'translate(83px, 119px)',
    ...commonOutlierProps,
};

const commonZoneProps: any = {
    textTransform: `translate(${zoneWidth / 2}px, ${zoneHeight / 2}px)`,
    type: 'zone',
    textAnchor: 'middle',
    dominantBaseline: 'middle',
};

const zone1: StrikeZoneRectMatrixProps = {
    value: '1',
    ...commonZoneProps
};

const zone2: StrikeZoneRectMatrixProps = {
    value: '2',
    ...commonZoneProps,
};

const zone3: StrikeZoneRectMatrixProps = {
    value: '3',
    ...commonZoneProps,
};

const zone4: StrikeZoneRectMatrixProps = {
    value: '4',
    ...commonZoneProps,
};

const zone5: StrikeZoneRectMatrixProps = {
    value: '5',
    ...commonZoneProps,
};

const zone6: StrikeZoneRectMatrixProps = {
    value: '6',
    ...commonZoneProps,
};

const zone7: StrikeZoneRectMatrixProps = {
    value: '7',
    ...commonZoneProps,
};

const zone8: StrikeZoneRectMatrixProps = {
    value: '8',
    ...commonZoneProps,
};

const zone9: StrikeZoneRectMatrixProps = {
    value: '9',
    ...commonZoneProps,
};

const batterOutlier11: StrikeZoneRectMatrixProps = {
    value: '11',
    ...commonOutlierUpperLeftProps,
};

const batterOutlier12: StrikeZoneRectMatrixProps = {
    value: '12',
    ...commonOutlierUpperRightProps,
};

const batterOutlier13: StrikeZoneRectMatrixProps = {
    value: '13',
    ...commonOutlierBottomLeftProps,
};

const batterOutlier14: StrikeZoneRectMatrixProps = {
    value: '14',
    ...commonOutlierBottomRightProps,
};

const pitcherOutlier11: StrikeZoneRectMatrixProps = {
    value: '11',
    ...commonOutlierUpperRightProps,
};

const pitcherOutlier12: StrikeZoneRectMatrixProps = {
    value: '12',
    ...commonOutlierUpperLeftProps,
};

const pitcherOutlier13: StrikeZoneRectMatrixProps = {
    value: '13',
    ...commonOutlierBottomRightProps,
};

const pitcherOutlier14: StrikeZoneRectMatrixProps = {
    value: '14',
    ...commonOutlierBottomLeftProps,
};

export const batterZoneMatrix: Array<Array<StrikeZoneRectMatrixProps>> = [
    [zone1, zone2, zone3],
    [zone4, zone5, zone6],
    [zone7, zone8, zone9],
];

export const batterOutlierMatrix: Array<Array<StrikeZoneRectMatrixProps>> = [
    [batterOutlier11, batterOutlier12],
    [batterOutlier13, batterOutlier14],
];

export const pitcherZoneMatrix: Array<Array<StrikeZoneRectMatrixProps>> = [
    [zone3, zone2, zone1],
    [zone6, zone5, zone4],
    [zone9, zone8, zone7],
];

export const pitcherOutlierMatrix: Array<Array<StrikeZoneRectMatrixProps>> = [
    [pitcherOutlier12, pitcherOutlier11],
    [pitcherOutlier14, pitcherOutlier13],
];